import { render, staticRenderFns } from "./StSummaryBox.vue?vue&type=template&id=3ca1aacc&scoped=true"
import script from "./StSummaryBox.vue?vue&type=script&lang=js"
export * from "./StSummaryBox.vue?vue&type=script&lang=js"
import style0 from "./StSummaryBox.vue?vue&type=style&index=0&id=3ca1aacc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca1aacc",
  null
  
)

export default component.exports